import { colors } from 'styles/variables'

type ZeroLineScale = {
  type: string
  min: number
  max: number
  options: { display?: boolean | `auto`; show_zero_line?: boolean }
  getPixelForValue: (value: number) => number
  getMatchingVisibleMetas: () => unknown[]
}

type ZeroLineChart = {
  scales: Record<string, ZeroLineScale>
}

type ZeroLineDrawChart = ZeroLineChart & {
  ctx: Pick<
    CanvasRenderingContext2D,
    'save' | 'restore' | 'beginPath' | 'moveTo' | 'lineTo' | 'stroke' | 'setLineDash' | 'strokeStyle' | 'lineWidth'
  >
  chartArea: { left: number; right: number }
}

function isScaleVisible(scale: ZeroLineScale): boolean {
  if (scale.options.display === `auto`) {
    return scale.getMatchingVisibleMetas().length > 0
  }
  return scale.options.display !== false
}

export function getZeroLinePixels(chart: ZeroLineChart): number[] {
  return Object.values(chart.scales)
    .filter((scale) => scale.options.show_zero_line && scale.type === `linear` && isScaleVisible(scale))
    .filter((scale) => scale.min <= 0 && scale.max >= 0)
    .map((scale) => scale.getPixelForValue(0))
}

export const zeroLinePlugin = {
  id: `zeroLine`,
  afterDatasetsDraw: function (chart: ZeroLineDrawChart) {
    const {
      ctx,
      chartArea: { left, right },
    } = chart

    ctx.save()
    ctx.strokeStyle = colors.black
    ctx.lineWidth = 1.5
    ctx.setLineDash([])

    getZeroLinePixels(chart).forEach((y) => {
      ctx.beginPath()
      ctx.moveTo(left, y)
      ctx.lineTo(right, y)
      ctx.stroke()
    })

    ctx.restore()
  },
}
